import { IconButton } from '@chakra-ui/react';
import { PageHeading } from '@duke-hq/ui/components/PageHeading';
import { ArrowRightFromLine } from 'lucide-react';
import { Trans } from '@lingui/react/macro';

import { useSubSidebar } from '@duke-hq/ui/components/SubSidebar/useSubSidebar';
import TableViewLayout from '@duke-hq/ui/components/TableViewLayout/TableViewLayout';

import { withPermission } from '../../withPermission';
import { PendingReferralsReport } from './PendingReferralsReport';

export const ProviderReports = withPermission('canViewProviders', () => {
  const { isExpanded, toggleExpandSubSidebar } = useSubSidebar();

  return (
    <TableViewLayout
      pageHeader={[
        !isExpanded && (
          <IconButton
            aria-label="expand secondary sidebar"
            icon={<ArrowRightFromLine />}
            variant="tertiary"
            onClick={toggleExpandSubSidebar}
            size="md"
          />
        ),
        <PageHeading key="page-heading">
          <Trans>Reports</Trans>
        </PageHeading>,
      ]}
      // main view
      table={<PendingReferralsReport />}
    />
  );
});
